module.exports = __webpack_public_path__ + "5b1109ed537b6422e57029674d661a28.jpg";